module.exports = __webpack_public_path__ + "img/logo.fbb63ae6.svg";